'use client'

import { useContext, useEffect } from 'react'
import { hasValidConsent, recordFirstInteraction } from '@achieve/cx-event-horizon/browser'
import { cookieStringHasConsentBanner } from 'constants/consentBannerCookies'
import { useBot } from 'hooks/useBot'
import { AnalyticsContext } from 'providers/AnalyticsProvider'
import { initializeConsentFirstInteraction } from 'utils/consent/consentFirstInteraction'
import { isEhConsentTealiumEnabled } from 'utils/consent/ehConsentTealiumEnabled'

/**
 * Wires EH consent for the pilot (ADR-011), for non-bot visitors only:
 * - a visitor who dismissed the legacy banner earlier is recorded once as `banner_ok`;
 * - otherwise the first qualifying click (never the banner's own controls) is recorded.
 */
export function EventHorizonConsentInit() {
  const {
    state: { analyticsInstance },
  } = useContext(AnalyticsContext)
  const { isBot } = useBot()

  useEffect(() => {
    if (!isEhConsentTealiumEnabled()) return undefined
    if (!analyticsInstance || isBot) return undefined

    if (!hasValidConsent() && cookieStringHasConsentBanner(document.cookie)) {
      recordFirstInteraction('banner_ok', { analytics: analyticsInstance })
      return undefined
    }

    return initializeConsentFirstInteraction({ analytics: analyticsInstance })
  }, [analyticsInstance, isBot])

  return null
}
